import React from 'react';
import { DashboardShell, TileSection, listCount, useRefreshKey, useAnyVisible } from '../../shared/LiveDashboard';

// Purchasing Dashboard: a live starter (shared/LiveDashboard.js). Purchase
// Orders aren't built yet, so it counts what Purchasing holds today.
const TILES = [
  { key: 'suppliers', label: 'Active Suppliers', screen: 'suppliers', icon: 'New Customers', count: listCount('/api/suppliers', { status: 'active' }), to: '/suppliers' },
  { key: 'rebate-rules', label: 'Supplier Rebate Rules', screen: 'purchasing-supplier-rebate-rules', icon: 'Revenue', count: listCount('/api/supplier-rebate-rules', { limit: 1 }), to: '/purchasing-supplier-rebate-rules' },
];

function PurchasingDashboard() {
  const [refreshKey, refresh] = useRefreshKey();
  const any = useAnyVisible(TILES);
  return (
    <DashboardShell
      title="Purchasing Dashboard"
      description={any ? 'Suppliers and rebates.' : 'Your Roles don’t include any of this dashboard’s cards.'}
      onRefresh={refresh}
    >
      <TileSection title="Key Figures" tiles={TILES} refreshKey={refreshKey} />
    </DashboardShell>
  );
}

export default PurchasingDashboard;
